import React, { Component } from 'react';

class DeletablePill extends Component {
  handleDeletePill = (event) => {
    const { deletePill, pillContent } = this.props;
    event.preventDefault();
    deletePill(pillContent);
  };

  render() {
    const { pillContent } = this.props;
    return (
      <div className="deletable-pill">
        <span>{pillContent}</span>
        <button role="link" onClick={this.handleDeletePill} >
          <i className="td-icon icon-ui-cross" />
        </button>
      </div>
    );
  }
}

export default DeletablePill;
